"use client";

import { c as _c } from "react/compiler-runtime";
import { type RefObject, useEffect } from "react";
import { loadGsapWithScrollTrigger, shouldReduceMotion } from "@/lib/gsap";
export function useServicesSectionAnimation(sectionRef) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== sectionRef) {
    t0 = () => {
      if (shouldReduceMotion()) {
        return;
      }
      let cleanup;
      let cancelled = false;
      const setupAnimation = async function setupAnimation() {
        const {
          gsap
        } = await loadGsapWithScrollTrigger();
        if (cancelled) {
          return;
        }
        const ctx = gsap.context(() => {
          const mobileCards = gsap.utils.toArray(".services-mobile-card");
          const desktopCards = gsap.utils.toArray(".services-desktop-card");
          const cards = [...mobileCards, ...desktopCards];
          gsap.set(cards, {
            opacity: 0,
            y: 42,
            rotateX: -7,
            filter: "blur(10px)",
            transformOrigin: "50% 100%"
          });
          gsap.to(cards, {
            opacity: 1,
            y: 0,
            rotateX: 0,
            filter: "blur(0px)",
            duration: 1.1,
            ease: "power3.out",
            stagger: {
              each: 0.08,
              from: "start"
            },
            scrollTrigger: {
              trigger: sectionRef.current,
              start: "top 82%",
              toggleActions: "play reverse restart reverse"
            }
          });
        }, sectionRef);
        cleanup = () => ctx.revert();
      };
      setupAnimation();
      return () => {
        cancelled = true;
        cleanup?.();
      };
    };
    t1 = [sectionRef];
    $[0] = sectionRef;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}